import { render, staticRenderFns } from "./FireFireplaceWhoMakesWorks.vue?vue&type=template&id=39f3dcb1&scoped=true"
import script from "./FireFireplaceWhoMakesWorks.vue?vue&type=script&lang=ts"
export * from "./FireFireplaceWhoMakesWorks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f3dcb1",
  null
  
)

export default component.exports